import axios from "../http";
let module = "/contact";
function contact(data){
  return axios.post(module,data);
}

export default{
  contact
}



// WEBPACK FOOTER //
// ./src/api/modules/contact.js